<div class="datiq-cell-menu">
    <datiq-menu
        [settings]="settings"
        (menuItemClicked)="menuItemClicked($event)"
    ></datiq-menu>
</div>
